// // src/components/admin/users/BusinessInvoicesAdmin.jsx
// import { useEffect, useState } from "react";
// import {
//   subscribeUserInvoices,
//   uploadInvoicePdf,
//   removeInvoice,
// } from "../../../services/invoicesService";

// export default function BusinessInvoicesAdmin({ uid }) {
//   const [list, setList] = useState([]);
//   const [file, setFile] = useState(null);
//   const [date, setDate] = useState("");

//   useEffect(() => {
//     if (!uid) return;
//     const unsub = subscribeUserInvoices(uid, setList);
//     return () => unsub && unsub();
//   }, [uid]);

//   const onUpload = async () => {
//     if (!file) return alert("Оберіть PDF");
//     await uploadInvoicePdf(uid, file, date || new Date());
//     setFile(null);
//     setDate("");
//   };

//   return (
//     <div
//       style={{
//         padding: 12,
//         border: "1px solid #eee",
//         borderRadius: 10,
//         background: "#fafafa",
//         marginTop: 8,
//       }}
//     >
//       <div style={{ fontWeight: 700, marginBottom: 8 }}>
//         Рахунки користувача
//       </div>

//       <div
//         style={{
//           display: "flex",
//           gap: 8,
//           alignItems: "center",
//           marginBottom: 10,
//         }}
//       >
//         <input
//           type="date"
//           value={date}
//           onChange={(e) => setDate(e.target.value)}
//         />
//         <input
//           type="file"
//           accept="application/pdf"
//           onChange={(e) => setFile(e.target.files?.[0] || null)}
//         />
//         <button
//           onClick={onUpload}
//           disabled={!file}
//           style={{ padding: "6px 10px", cursor: "pointer" }}
//         >
//           Завантажити рахунок
//         </button>
//       </div>

//       {list.length === 0 ? (
//         <div style={{ color: "#666" }}>Рахунків ще немає.</div>
//       ) : (
//         <ul
//           style={{
//             listStyle: "none",
//             padding: 0,
//             margin: 0,
//             display: "grid",
//             gap: 6,
//           }}
//         >
//           {list.map((inv) => (
//             <li
//               key={inv.id}
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 padding: "8px 10px",
//                 background: "#fff",
//                 border: "1px solid #eee",
//                 borderRadius: 8,
//               }}
//             >
//               <div>
//                 <div style={{ fontWeight: 600 }}>
//                   {inv.orderDate?.toDate
//                     ? inv.orderDate.toDate().toLocaleDateString()
//                     : new Date(inv.orderDate).toLocaleDateString()}
//                 </div>
//                 <div style={{ fontSize: 12, color: "#666" }}>
//                   {inv.fileName}
//                 </div>
//               </div>
//               <div style={{ display: "flex", gap: 8 }}>
//                 <a
//                   href={`https://docs.google.com/gview?embedded=1&url=${encodeURIComponent(
//                     inv.url
//                   )}`}
//                   target="_blank"
//                   rel="noreferrer"
//                   style={{
//                     textDecoration: "none",
//                     padding: "6px 10px",
//                     border: "1px solid #3e51c1",
//                     color: "#3e51c1",
//                     borderRadius: 8,
//                   }}
//                 >
//                   Відкрити
//                 </a>
//                 <button
//                   onClick={() => removeInvoice(uid, inv)}
//                   style={{
//                     padding: "6px 10px",
//                     background: "#dc2626",
//                     color: "#fff",
//                     border: "none",
//                     borderRadius: 8,
//                     cursor: "pointer",
//                   }}
//                 >
//                   Видалити
//                 </button>
//               </div>
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// }
import { useEffect, useRef, useState } from "react";
import {
  subscribeUserInvoices,
  uploadInvoiceFile,
  removeInvoice,
} from "../../../services/invoicesService";

const ACCEPTED_FILES = `
.pdf,
.xlsx,
.xls,
.docx,
.doc,
.csv,
.txt,
.jpg,
.jpeg,
.png,
.webp,
application/pdf,
application/vnd.ms-excel,
application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
application/msword,
application/vnd.openxmlformats-officedocument.wordprocessingml.document,
text/csv,
text/plain,
image/jpeg,
image/png,
image/webp
`
  .replace(/\s+/g, "")
  .trim();

function formatDate(value) {
  try {
    if (value?.toDate) {
      return value.toDate().toLocaleDateString("uk-UA");
    }

    if (value) {
      return new Date(value).toLocaleDateString("uk-UA");
    }

    return "Без дати";
  } catch (error) {
    console.error("Date format error:", error);
    return "Без дати";
  }
}

function getFileTypeLabel(fileName = "") {
  const name = String(fileName || "").toLowerCase();

  if (name.endsWith(".pdf")) return "PDF";
  if (name.endsWith(".xlsx") || name.endsWith(".xls")) return "Excel";
  if (name.endsWith(".docx") || name.endsWith(".doc")) return "Word";
  if (name.endsWith(".csv")) return "CSV";
  if (name.endsWith(".txt")) return "TXT";

  if (
    name.endsWith(".jpg") ||
    name.endsWith(".jpeg") ||
    name.endsWith(".png") ||
    name.endsWith(".webp")
  ) {
    return "Зображення";
  }

  return "Файл";
}

export default function BusinessInvoicesAdmin({ uid }) {
  const [list, setList] = useState([]);
  const [file, setFile] = useState(null);
  const [date, setDate] = useState("");
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (!uid) {
      setList([]);
      return;
    }

    const unsub = subscribeUserInvoices(uid, (items) => {
      setList(Array.isArray(items) ? items : []);
    });

    return () => {
      if (typeof unsub === "function") unsub();
    };
  }, [uid]);

  const onUpload = async () => {
    if (!uid) {
      alert("Не знайдено користувача");
      return;
    }

    if (!file) {
      alert("Оберіть файл");
      return;
    }

    try {
      setUploading(true);
      await uploadInvoiceFile(uid, file, date || new Date());

      setFile(null);
      setDate("");

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      console.error("Upload error:", error);
      alert("Не вдалося завантажити файл.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div
      style={{
        padding: 12,
        border: "1px solid #eee",
        borderRadius: 10,
        background: "#fafafa",
        marginTop: 8,
      }}
    >
      <div style={{ fontWeight: 700, marginBottom: 8 }}>Файли користувача</div>

      <div
        style={{
          display: "flex",
          gap: 8,
          alignItems: "center",
          marginBottom: 10,
          flexWrap: "wrap",
        }}
      >
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />

        <input
          ref={fileInputRef}
          type="file"
          accept={ACCEPTED_FILES}
          onChange={(e) => setFile(e.target.files?.[0] || null)}
        />

        <button
          type="button"
          onClick={onUpload}
          disabled={!file || uploading}
          style={{
            padding: "6px 10px",
            cursor: !file || uploading ? "not-allowed" : "pointer",
          }}
        >
          {uploading ? "Завантаження..." : "Завантажити файл"}
        </button>

        {file && (
          <div style={{ fontSize: 12, color: "#666" }}>Обрано: {file.name}</div>
        )}
      </div>

      <div style={{ fontSize: 12, color: "#64748b", marginBottom: 10 }}>
        Дозволені файли: PDF, Excel, Word, CSV, TXT, JPG, PNG, WEBP
      </div>

      {list.length === 0 ? (
        <div style={{ color: "#666" }}>Файлів ще немає.</div>
      ) : (
        <ul
          style={{
            listStyle: "none",
            padding: 0,
            margin: 0,
            display: "grid",
            gap: 6,
          }}
        >
          {list.map((inv) => (
            <li
              key={inv.id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px 10px",
                background: "#fff",
                border: "1px solid #eee",
                borderRadius: 8,
                gap: 12,
                flexWrap: "wrap",
              }}
            >
              <div>
                <div style={{ fontWeight: 600 }}>
                  {formatDate(inv.orderDate)}
                </div>

                <div style={{ fontSize: 12, color: "#666" }}>
                  {inv.fileName || "Файл без назви"}
                </div>

                <div style={{ fontSize: 12, color: "#94a3b8" }}>
                  Тип: {getFileTypeLabel(inv.fileName)}
                </div>
              </div>

              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <a
                  href={inv.url}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    textDecoration: "none",
                    padding: "6px 10px",
                    border: "1px solid #3e51c1",
                    color: "#3e51c1",
                    borderRadius: 8,
                  }}
                >
                  Відкрити файл
                </a>

                <button
                  type="button"
                  onClick={() => removeInvoice(uid, inv)}
                  style={{
                    padding: "6px 10px",
                    background: "#dc2626",
                    color: "#fff",
                    border: "none",
                    borderRadius: 8,
                    cursor: "pointer",
                  }}
                >
                  Видалити
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
